(() => {
  'use strict';
  const formId = 'WiVzYW';
  const key = 'h17-email-signup-v1';
  const cooldown = 14 * 24 * 60 * 60 * 1000;
  const started = Date.now();
  let attempted = false;
  let checking = false;
  let engaged = false;

  // This script is rendered only for signed-out visitors. Custom Klaviyo
  // triggers bypass native targeting, so all eligibility checks live here.
  if (/wholesale|partner|account|cart|checkout|fitment|shop-now/i.test(location.pathname)) return;

  function remembered() {
    try {
      const saved = JSON.parse(localStorage.getItem(key) || 'null');
      return saved?.subscribed === true || Date.now() - Number(saved?.lastShown || 0) < cooldown;
    } catch (_) {
      // If storage is unavailable, do not repeatedly interrupt the visitor.
      return true;
    }
  }

  function visible(element) {
    if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
    const box = element.getBoundingClientRect();
    return box.width > 0 && box.height > 0;
  }

  function ready() {
    const privacy = window.Shopify?.customerPrivacy;
    const finder = document.querySelector('#find-your-lighting-kit')?.getBoundingClientRect();
    const browsingFitment = finder && finder.bottom > 0 && finder.top < window.innerHeight;
    return !attempted && engaged && !document.hidden && Date.now() - started >= 30000 &&
      !remembered() && privacy?.marketingAllowed?.() === true &&
      !browsingFitment &&
      !visible(document.querySelector('[data-h17-cookie-banner]')) &&
      !Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(visible) &&
      !document.activeElement?.matches('input, select, textarea, [contenteditable="true"]');
  }

  function remember(subscribed = false) {
    try {
      const previous = JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify({ lastShown: Date.now(), subscribed: subscribed || previous?.subscribed === true }));
    } catch (_) { /* The current page still remains limited to one display. */ }
  }

  async function consider() {
    if (checking || !ready() || typeof window.klaviyo?.isIdentified !== 'function') return;
    checking = true;
    try {
      const identified = await window.klaviyo.isIdentified();
      if (identified === true) {
        attempted = true;
        return;
      }
      if (identified !== false || !ready() || typeof window.klaviyo.openForm !== 'function') return;
      attempted = true;
      remember();
      window.klaviyo.openForm(formId);
    } catch (_) { /* Missing or blocked marketing scripts must not affect shopping. */ }
    finally { checking = false; }
  }

  window.addEventListener('scroll', () => {
    if (window.scrollY > 200) engaged = true;
  }, { passive: true });
  window.addEventListener('klaviyoForms', (event) => {
    if (event.detail?.formId !== formId) return;
    if (['open', 'close', 'submit'].includes(event.detail.type)) remember(event.detail.type === 'submit');
  });
  // A native footer signup should also suppress the popup on this browser.
  document.querySelector('.h17-footer__form')?.addEventListener('submit', () => {
    attempted = true;
    remember(true);
  });
  const timer = window.setInterval(() => {
    if (attempted || Date.now() - started > 10 * 60 * 1000) window.clearInterval(timer);
    else consider();
  }, 2000);
})();
